import { BOOKING_AGENCY } from '@/data/events';
import type { Resident } from '@/types';

import styles from './BookingBlock.module.css';

interface BookingBlockProps {
  artist: Resident;
  showCta: boolean;
  onRequestBooking?: () => void;
}

export default function BookingBlock({ artist, showCta, onRequestBooking }: BookingBlockProps) {
  return (
    <section className={styles.section} id="booking">
      <header className={styles.head}>
        <span className={styles.num}>/ 04</span>
        <span className={styles.ttl}>BOOKING</span>
        <span className={styles.meta}>VIA {BOOKING_AGENCY.name}</span>
      </header>

      <div className={styles.block}>
        <div className={styles.copy}>
          <h2>BOOK {artist.name}.</h2>
          <p>
            {artist.name} is booked through <b>{BOOKING_AGENCY.name}</b>. We don&apos;t list rates
            publicly — every inquiry is reviewed by our team. Send a request below.
          </p>
          <p>
            For press, mixes, or non-booking matters, write directly to {BOOKING_AGENCY.email}.
          </p>
        </div>
        <div className={styles.agency}>
          <div className={styles.row}>
            <span>AGENCY</span>
            <span className={styles.v}>{BOOKING_AGENCY.name}</span>
          </div>
          <div className={styles.row}>
            <span>BASED</span>
            <span className={styles.v}>{BOOKING_AGENCY.city}</span>
          </div>
          <div className={styles.row}>
            <span>HOURS</span>
            <span className={styles.v}>{BOOKING_AGENCY.hours}</span>
          </div>
          <div className={styles.row}>
            <span>REPLY</span>
            <span className={styles.v}>{BOOKING_AGENCY.reply}</span>
          </div>
          {showCta && (
            <button type="button" className={styles.cta} onClick={onRequestBooking}>
              <span>REQUEST BOOKING</span>
              <span>→</span>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
